import _ from "lodash";
const Lodash = _;
export default Lodash;
